import React from 'react'
import Edit from '../crud/edit'
import fields from './edit-fields'
import menuItems from './menuItems'

const EditUserMembership = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Individual Membership'
      fields={fields}
      apiPath={`admin/memberships/${props.params.membershipId}`}
      successRedirectPath='/membership/user-memberships'
      buildMenuItems={menuItems}
    />
  )
}

export default EditUserMembership
